import {
  faLeaf,
  faHome,
  faGlassMartini,
  faCar,
  faStar,
  faFrown,
  faUsers,
  faTree,
  faMagic,
  faBook,
  faChild,
  faUserFriends,
  faCrow,
  faBomb,
} from '@fortawesome/fontawesome-free-solid';

const getIconByCategoryId = categoryId => {
  switch (categoryId) {
    case '0':
      return faLeaf;
    case '1':
      return faChild;
    case '2':
      return faHome;
    case '3':
      return faGlassMartini;
    case '4':
      return faCar;
    case '5':
      return faStar;
    case '6':
      return faUserFriends;
    case '7':
      return faUsers;
    case '8':
      return faCrow;
    case '9':
      return faTree;
    case '10':
      return faBomb;
    case '11':
      return faMagic;
    case '12':
      return faBook;
    default:
      return faFrown;
  }
};

export default getIconByCategoryId;



// WEBPACK FOOTER //
// lib/getIconByCategoryId.js